import { __decorate, __metadata } from "tslib";
import { IsUndefinable } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNumber } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
export class ReadElementTotalAmountsDto {
}
__decorate([
    ApiProperty({
        type: () => Number,
        description: "The total price of all items sold in the item. The price is calculated as item's basePrice multiplied by quantity. It does not include modifiers.",
        example: 100,
    }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadElementTotalAmountsDto.prototype, "basePrice", void 0);
__decorate([
    ApiProperty({
        type: () => Number,
        description: 'The amount of money made in gross sales for the item. The amount is calculated as the sum of the price with modifiers multiplied by quantity',
        example: 100,
    }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadElementTotalAmountsDto.prototype, "grossSales", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'The total amount of tax money to collect for the item.', example: 100 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadElementTotalAmountsDto.prototype, "tax", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'The total amount of discount money to collect for the item.', example: 100 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadElementTotalAmountsDto.prototype, "discount", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'The total amount of money to collect for the item (after all discount, taxes, etc).', example: 100 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadElementTotalAmountsDto.prototype, "total", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: 'The total amount of adjustment money (it does not include taxes)', example: 100 }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ],
    }),
    __metadata("design:type", Number)
], ReadElementTotalAmountsDto.prototype, "priceAdjustmentMoney", void 0);
//# sourceMappingURL=ReadElementTotalAmountsDto.js.map